import React, {Component} from 'react';

class Class390 extends Component {
    render() {
        return (
            <div>
                <div className='main-text'>
                    <h1>British Rail Class 390</h1>
                    If I'm honest, I have mixed feelings about these units. I like their outside appearance, and their ability to operate at 140 MPH (Despite being limited to 125 MPH at present), as well as their tilting technology that is well suited for the curvy West Coast Main Line that they can be found on. I also like how, unlike many trains these days, they have catering facities available for passengers. However, they do feel quite cramped due to the narrow body shape which is required for them to tilt, and the windows are quite small, with some seats not having one at all!
                    <p/>
 
                    <div className='embed-responsive embed-responsive-16by9'>
                        <iframe className='embed-responsive-item' src='https://www.youtube.com/embed/REk8kWj_iFY' allowFullScreen title='A YouTube video of a ride on a Class 390 en-route to Birmingham from London'></iframe>
                    </div>
                </div>
            </div>
        );
    }
}

export default Class390;